import { configWithTokenId } from '@api/constructor-api'

function apiCreateCustomerFeedback(body) {
  return configWithTokenId((API) => {
    if(body.branch_uuid != null && body.branch_uuid != 'null')
      return API.post('/customer-feedback', body)
    throw 'Not Empty Data'
  })
}

export {
  apiCreateCustomerFeedback,
}